import Hashids from 'hashids';
import _isNumber from 'lodash/isNumber';
import _isString from 'lodash/isString';
import authUtils from '@/utils/auth';

const SALT = 'smartclass';
const hashids = new Hashids(SALT);
const INVITE_LIFE_TIME = 1000 * 60 * 60 * 24 * 7;
const reg = /^\/(en|pl|ro)\/(free\/login|login|login-qa)\/([0-9a-zA-z]*)\/?([0-9a-zA-z]*)\/$/i;

export const encodeInviteLink = (
  {
    courseId,
    teacherId,
    b2bCompanyId,
  } : {
    courseId?: number;
    teacherId?: number;
    b2bCompanyId?: number;
  },
): string | '' => {
  let link = '';
  let path = '';

  const token = authUtils.getAccessToken();
  const userData = authUtils.convertToken(token);

  userData.roles?.forEach((el: string) => {
    if (el === 'ROLE_TEACHER_PAY' || el === 'ROLE_B2B_ADMIN' || userData.sub === 'b2b@englishdom.com') {
      path = 'login';
    }
  });

  if (
    _isNumber(courseId)
    && _isNumber(teacherId)
  ) {
    link = [
      window.location.origin,
      path,
      hashids.encode(courseId, teacherId, Date.now()),
      '',
    ].join('/');
  } else if (b2bCompanyId) {
    link = [
      window.location.origin,
      path,
      hashids.encode(b2bCompanyId),
      'company',
    ].join('/');
  }

  return `${link}#signup`;
};

export const hasInviteLink = (link: string) => _isString(link)
  && reg.test(link)
  && reg.exec(link) !== null
  && reg.exec(link)[3];

export const decodeInviteLink = (link: string): undefined | {
  courseId?: number;
  teacherId?: number;
  b2bCompany?: string;
} => {
  let obj;

  if (hasInviteLink(link)) {
    if (reg.exec(link)[3] && !reg.exec(link)[4]) {
      const encoded = reg.exec(link)[3];
      const [courseId, teacherId, createdDate] = hashids.decode(encoded);
      const currentDate = Date.now();
      const diff = currentDate - (createdDate as number ?? 0);

      if (courseId && teacherId && createdDate && diff < INVITE_LIFE_TIME) {
        obj = {
          courseId,
          teacherId,
          encoded,
        };
      }
    } else if (reg.exec(link)[4]) {
      const encoded = reg.exec(link)[3];

      obj = {
        b2bCompanyId: hashids.decode(encoded)[0],
      };
    }
  } else {
    //
  }

  return obj;
};
